import {useEffect} from "react";

const SITE = {
    name: "COMPASSIA",
    domain: "https://compassia.es",
    email: "info@compassia.es",
    phone: "+34 600 000 000",
    city: "Barcelona",
    country: "España",
    tagline: "Optimización sin fricción",
    description:
        "Automatizamos y optimizamos procesos con tu stack actual. Pilotos de 2–4 semanas con objetivos medibles. Integraciones n8n, RAG privado en AWS, Leads/CRM, contratos y aprobaciones, onboarding/offboarding y reporting.",
    keywords:
        "automatización PYMES, n8n, RAG privado, AWS, NetSuite, integración ERP CRM, IA aplicada, dashboards KPIs, gestión de agenda, clasificación de leads, firma electrónica, aprobaciones, onboarding, reporting, proyectos a medida",
    ogImage: "/og-compassia.jpg",
    twitter: "@compassia",
};

export function SEOManager() {
    useEffect(() => {
        const title = `COMPASSIA | ${SITE.tagline}`;
        const desc = SITE.description;
        const url = SITE.domain;

        const ensure = (tagName, attrs) => {
            const selector = Object.entries(attrs)
                .map(([k, v]) => `[${k}="${v}"]`)
                .join("");
            let el = document.head.querySelector(`${tagName}${selector}`);
            if (!el) {
                el = document.createElement(tagName);
                for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
                document.head.appendChild(el);
            }
            return el;
        };

        document.title = title;
        ensure("meta", { name: "description" }).setAttribute("content", desc);
        ensure("link", { rel: "canonical" }).setAttribute("href", url);
        ensure("meta", { name: "keywords" }).setAttribute("content", SITE.keywords);

        // Open Graph
        ensure("meta", { property: "og:type" }).setAttribute("content", "website");
        ensure("meta", { property: "og:title" }).setAttribute("content", title);
        ensure("meta", { property: "og:description" }).setAttribute("content", desc);
        ensure("meta", { property: "og:url" }).setAttribute("content", url);
        ensure("meta", { property: "og:site_name" }).setAttribute("content", SITE.name);
        ensure("meta", { property: "og:image" }).setAttribute("content", SITE.ogImage);

        // Twitter
        ensure("meta", { name: "twitter:card" }).setAttribute("content", "summary_large_image");
        ensure("meta", { name: "twitter:title" }).setAttribute("content", title);
        ensure("meta", { name: "twitter:description" }).setAttribute("content", desc);
        ensure("meta", { name: "twitter:image" }).setAttribute("content", SITE.ogImage);
        ensure("meta", { name: "twitter:site" }).setAttribute("content", SITE.twitter);

        // JSON-LD (Organization + Services + FAQ)
        const jsonLd = [
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                name: SITE.name,
                url: SITE.domain,
                email: SITE.email,
                telephone: SITE.phone,
                address: {
                    "@type": "PostalAddress",
                    addressLocality: SITE.city,
                    addressCountry: SITE.country,
                },
                sameAs: [],
                logo: `${SITE.domain}/logo.png`,
            },
            {
                "@context": "https://schema.org",
                "@type": "Service",
                name: "Automatización y Optimización de Procesos",
                provider: { "@type": "Organization", name: SITE.name },
                areaServed: "ES",
                serviceType:
                    "Integraciones n8n, RAG privado en AWS, Leads/CRM, Firma y contratos, Aprobaciones, Onboarding/Offboarding, Reporting",
                description: SITE.description,
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: [
                    {
                        "@type": "Question",
                        name: "¿Trabajáis con mi stack actual?",
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "Sí. Nos integramos con tus herramientas (ERP/CRM, Drive, Slack/WhatsApp, Calendar) y evitamos re-plataformar.",
                        },
                    },
                    {
                        "@type": "Question",
                        name: "¿El RAG es privado y seguro?",
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "Sí. Se despliega en tu AWS (VPC, KMS, IAM). No se entrenan modelos con tus datos y las respuestas incluyen fuentes.",
                        },
                    },
                    {
                        "@type": "Question",
                        name: "¿Hacéis proyectos a medida?",
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "Sí. Ofrecemos 'Proyecto a medida (Scope & Build)': descubrimiento, alcance por fases, piloto 2–4 semanas y plan de escalado.",
                        },
                    },
                ],
            },
        ];
        const scriptId = "jsonld-compassia";
        let script = document.getElementById(scriptId);
        if (!script) {
            script = document.createElement("script");
            script.id = scriptId;
            script.type = "application/ld+json";
            document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(jsonLd);
    }, []);

    return null;
}